class Accordion extends HTMLElement {
  static firstInitialized = false;

  constructor() {
    super();
    this.$title = this.querySelector('accordion-title');
    this.$content = this.querySelector('accordion-content');
    this.$icon = this.querySelector('.accordion-icon');
    this.isOpen = false;
    this.height = 0;

    this.events();
    if (!Accordion.firstInitialized) {
      Accordion.firstInitialized = true;
      this.alwaysOpen();
    } else {
      this.close();
    }
  }

  events() {
    this.$title.addEventListener('click', this.handleClick.bind(this));
    this.$content.addEventListener('transitionend', this.handleTransition.bind(this));
  }

  handleClick() {
    this.height = this.$content.scrollHeight;
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  close() {
    this.isOpen = false;
    this.classList.remove('active');
    this.$icon.classList.remove('active');
    this.$content.style.maxHeight = `${this.height}px`;

    setTimeout(() => {
      this.$content.style.maxHeight = `${0}px`;
    }, 1);
  }

  open() {
    this.isOpen = true;
    this.classList.add('active');
    this.$icon.classList.add('active');
    this.$content.classList.remove('is-hidden');
    this.$content.style.maxHeight = `${0}px`;

    setTimeout(() => {
      this.$content.style.maxHeight = `${this.height}px`;
    }, 1);
  }

  alwaysOpen() {
    this.isOpen = true;
    this.classList.add('active');
    this.$icon.classList.add('active');
    this.$content.classList.remove('is-hidden');
    this.$content.style.maxHeight = `${this.$content.scrollHeight}px`;
  }

  handleTransition() {
    if (!this.isOpen) {
      this.$content.classList.add('is-hidden');
    }
    this.$content.style.maxHeight = '';
  }
}

customElements.define('single-accordion', Accordion);
